var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBWrench(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-wrench",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-wrench1",
    serifid: "iconB-wrench"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.33,10.245c-0.021,-0.101 -0.073,-0.342 -0.131,-0.583c-0.13,-0.533 -0.199,-1.089 -0.199,-1.662c0,-3.866 3.134,-7 7,-7c1.027,-0 2.003,0.222 2.882,0.619c0.299,0.135 0.513,0.409 0.571,0.732c0.059,0.323 -0.044,0.654 -0.276,0.886c0,-0 -3.167,3.181 -3.241,3.263c0.074,0.082 1.482,1.49 1.564,1.564c0.082,-0.074 3.263,-3.241 3.263,-3.241c0.232,-0.232 0.563,-0.335 0.886,-0.277c0.323,0.059 0.597,0.273 0.732,0.572c0.397,0.879 0.619,1.855 0.619,2.882c-0,3.866 -3.134,7 -7,7c-0.573,-0 -1.129,-0.069 -1.662,-0.199c-0.241,-0.058 -0.482,-0.11 -0.583,-0.131c-0.057,0.053 -0.182,0.171 -0.3,0.289l-6.248,6.248c-1.219,1.219 -3.195,1.219 -4.414,-0c-1.219,-1.219 -1.219,-3.195 -0,-4.414l6.248,-6.248c0.117,-0.118 0.236,-0.243 0.289,-0.3Zm5.594,-1.907c-0.569,-0.569 -0.805,-0.892 -0.912,-1.22c-0.13,-0.402 -0.13,-0.834 -0,-1.236c0.107,-0.328 0.343,-0.651 0.912,-1.22c-0,0 1.631,-1.632 1.632,-1.631c-0.182,-0.021 -0.368,-0.031 -0.556,-0.031c-2.761,0 -5,2.239 -5,5c-0,0.41 0.049,0.808 0.142,1.188c0.159,0.655 0.208,0.987 0.194,1.194c-0.022,0.323 -0.07,0.495 -0.219,0.783c-0.102,0.195 -0.275,0.407 -0.662,0.794l-6.248,6.248c-0.438,0.438 -0.438,1.148 -0,1.586c0.438,0.438 1.148,0.438 1.586,0l6.248,-6.248c0.387,-0.387 0.599,-0.56 0.794,-0.662c0.288,-0.149 0.46,-0.197 0.783,-0.219c0.207,-0.014 0.539,0.035 1.194,0.194c0.38,0.093 0.778,0.142 1.188,0.142c2.761,0 5,-2.239 5,-5c-0,-0.188 -0.01,-0.373 -0.03,-0.555l-1.632,1.631c-0.569,0.569 -0.892,0.805 -1.22,0.912c-0.402,0.13 -0.834,0.13 -1.236,0c-0.328,-0.107 -0.651,-0.343 -1.221,-0.912l-0.737,-0.738Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBWrench);
export default __webpack_public_path__ + "static/media/iconB-wrench.dd6416a46445e87a72616caf6d51a03f.svg";
export { ForwardRef as ReactComponent };